import {
  collection as caseInfoCollection,
  schema as caseInfoSchema,
  fetch as fetchCaseInfo,
} from './caseInfo'
import {
  schema as copyWorkflowSchema,
  create as createCopyWorkflow,
} from './copyWorkflow'
import {
  create as createImportWorkflow,
  collection as importWorkflowCollection,
  schema as importWorkflowSchema,
} from './importWorkflow'
import {
  fetch as fetchInputAndOutputDescriptors,
  collection as inputAndOutputDescriptorsCollection,
  schema as inputAndOutputDescriptorsSchema,
} from './inputAndOutputDescriptors'
import {
  fetch as fetchInputDescriptors,
  schema as fetchInputDescriptorsSchema,
  collection as inputDescriptorsCollection,
} from './inputDescriptors'
import { create as createLockWorkflow } from './lockWorkflow'
import {
  fetch as fetchOutputDescriptors,
  schema as fetchOutputDescriptorsSchema,
  collection as outputDescriptorsCollection,
} from './outputDescriptors'
import { create as createRepublishVersion } from './republishVersion'
import { create as createRestoreVersion } from './restoreVersion'
import {
  fetch as fetchTemplates,
  collection as templatesCollection,
  schema as templatesSchema,
} from './templates'
import { create as createUnlockWorkflow } from './unlockWorkflow'
import {
  create as createVersion,
  schema as versionSchema,
  collection as versionsCollection,
} from './version'
import { fetch as fetchVersions, schema as versionsSchema } from './versions'
import {
  create as createWorkflow,
  fetch as fetchWorkflow,
  remove as removeWorkflow,
  update as updateWorkflow,
  collection as workflowCollection,
  schema as workflowSchema,
} from './workflow'
import {
  fetch as fetchWorkflowSummary,
  schema as fetchWorkflowSummarySchema,
  collection as workflowSummariesCollection,
} from './workflowSummary'
import {
  fetch as fetchWorkflowSummaries,
  schema as fetchWorkflowSummariesSchema,
} from './workflowsSummaries'
import {
  fetch as fetchWorkflowPreview,
  schema as fetchWorkflowPreviewSchema,
  collection as workflowPreviewCollection,
} from './workflowsPreview'

export {
  TEST_SCRIPT,
  LINT_SCRIPT,
  FIX_SCRIPT,
  DMN_REVISION_INFO,
  DMN_UPDATE_REVISION,
  DMN_MODEL_INFO,
  EXTERNAL_ACTIVITY_INFOS,
  EXTERNAL_ACTIVITY_CONFIGURATION_INFO,
} from './activities'

export const WORKFLOW = {
  collection: workflowCollection,
  schema: workflowSchema,
  fetch: fetchWorkflow,
  update: updateWorkflow,
  create: createWorkflow,
  remove: removeWorkflow,
}

export const COPY_WORKFLOW = {
  create: createCopyWorkflow,
  schema: copyWorkflowSchema,
  collection: workflowCollection,
}

export const WORKFLOW_SUMMARY = {
  fetch: fetchWorkflowSummary,
  schema: fetchWorkflowSummarySchema,
  collection: workflowSummariesCollection,
}

export const WORKFLOW_PREVIEW = {
  fetch: fetchWorkflowPreview,
  schema: fetchWorkflowPreviewSchema,
  collection: workflowPreviewCollection,
}

export const WORKFLOW_SUMMARIES = {
  fetch: fetchWorkflowSummaries,
  schema: fetchWorkflowSummariesSchema,
  collection: workflowSummariesCollection,
}

export const INPUT_DESCRIPTORS = {
  fetch: fetchInputDescriptors,
  schema: fetchInputDescriptorsSchema,
  collection: inputDescriptorsCollection,
}

export const OUTPUT_DESCRIPTORS = {
  fetch: fetchOutputDescriptors,
  schema: fetchOutputDescriptorsSchema,
  collection: outputDescriptorsCollection,
}

export const INPUT_AND_OUTPUT_DESCRIPTORS = {
  collection: inputAndOutputDescriptorsCollection,
  fetch: fetchInputAndOutputDescriptors,
  schema: inputAndOutputDescriptorsSchema,
}

export const LOCK_WORKFLOW = {
  create: createLockWorkflow,
  schema: workflowSchema,
  collection: workflowCollection,
}

export const UNLOCK_WORKFLOW = {
  create: createUnlockWorkflow,
  schema: workflowSchema,
  collection: workflowCollection,
}

export const VERSION = {
  create: createVersion,
  schema: versionSchema,
  collection: versionsCollection,
}

export const VERSIONS = {
  fetch: fetchVersions,
  schema: versionsSchema,
  collection: versionsCollection,
}

export const RESTORE_VERSION = {
  create: createRestoreVersion,
  schema: versionSchema,
  collection: versionsCollection,
}

export const REPUBLISH_VERSION = {
  create: createRepublishVersion,
  schema: versionSchema,
  collection: versionsCollection,
}

export const WORKFLOW_TEMPLATES = {
  fetch: fetchTemplates,
  collection: templatesCollection,
  schema: templatesSchema,
}

export const IMPORT_WORKFLOW = {
  collection: importWorkflowCollection,
  schema: importWorkflowSchema,
  create: createImportWorkflow,
}

export const WORKFLOW_CASE_INFO = {
  collection: caseInfoCollection,
  schema: caseInfoSchema,
  fetch: fetchCaseInfo,
}
